import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';
import {Tag, Modal ,message} from 'antd';
import moment from 'moment';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}


const columns = utils.columns([
    {
        key:'$index', 
        label: '序号'
    },
    {
        key: 'orgName',
        width: 120,
        label: '所属部门'
    },
    {
        key: 'classesName', 
        width: 130,
        label: '所属班级'
    },
    {
        key: 'studentNo', 
        width: 100,
        label: '学号'
    },
    {
        key: 'studentName', 
        width: 85,
        label: '姓名'
    },
    {
        key: 'yearSystemName',
         width: 80,
        label: '学制'
    },
    {
        key: 'classGrade', 
        width: 80,
        label: '年级'
    },
    {
        key: 'targetName', 
        width: 170,
        label: '细则名称',
    },
    {
        key: 'enterStatus',
        width: 90,
        label: '是否填报',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#52c41a" >{'已填报'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未填报'}</Tag></span>
            }
        }
    },
    {
        key: 'enterNum', 
        width: 80,
        label: '填报数',
    },
    {
        key: 'noAuditNum', 
        width: 100,
        label: '班级未审核',
    },
    {
        key: 'qualifyStatus',
        width: 90,
        label: '是否达标',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#52c41a" >{'已达标'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未达标'}</Tag></span>
            }
        }
    },
    {
        key: 'allAuditScore',
        width: 80,
        label: '总积分'
    },
    {
        key: 'earlyWarnStatus',
        width: 90,
        label: '总预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'endYearName',
        label: '结束学年'
    },
    {
        key: 'firstYearLowScore', 
        width: 150,
        label: '第一学年最低积分',
    },
    {
        key: 'firstYearEnterScore', 
        width: 150,
        label: '第一学年录入积分',
    },
    {
        key: 'firstYearScore', 
        width: 150,
        label: '第一学年已审核积分',
    },
    {
        key: 'firstYearWarnStatus', 
        width: 150,
        label: '第一学年预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'firstYearModuleWarnStatus', 
        width: 150,
        label: '第一学年模块预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'secondYearLowScore', 
        width: 150,
        label: '第二学年最低积分',
    },
    {
        key: 'secondYearEnterScore', 
        width: 150,
        label: '第二学年录入积分',
    },
    {
        key: 'secondYearScore', 
        width: 150,
        label: '第二学年已审核积分',
    },
    {
        key: 'secondYearWarnStatus', 
        width: 150,
        label: '第二学年预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'secondYearModuleWarnStatus', 
        width: 150,
        label: '第二学年模块预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'threeYearLowScore', 
        width: 150,
        label: '第三学年最低积分',
    },
    {
        key: 'threeYearEnterScore', 
        width: 150,
        label: '第三学年录入积分',
    },
    {
        key: 'threeYearScore', 
        width: 150,
        label: '第三学年已审核积分',
    },
    {
        key: 'threeYearWarnStatus', 
        width: 150,
        label: '第三学年预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'threeYearModuleWarnStatus', 
        width: 150,
        label: '第三学年模块预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'fourYearLowScore', 
        width: 150,
        label: '第四学年最低积分',
    },
    {
        key: 'fourYearEnterScore', 
        width: 150,
        label: '第四学年录入积分',
    },
    {
        key: 'fourYearScore', 
        width: 150,
        label: '第四学年已审核积分',
    },
    {
        key: 'fourYearWarnStatus', 
        width: 150,
        label: '第四学年预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'fourYearModuleWarnStatus', 
        width: 150,
        label: '第四学年模块预警',render:(value) =>{
            if(value){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    }
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else if(i === 'order'){
            params.push(`order=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('second/credit/collect2/query?'+ params.join('&'), newKeyword)
    .then((response) => {
        if(response.code === 200) {
            return {
                data: response.payload.data,
                meta: response.payload.meta
            };
        }
    }).then(response => (
        Object.assign({
            result: response.data.dataList || [],
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            meta: response.meta,
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const getDetailById = (id) => {
    return fetch.get('second/credit/collect2/detail/'+ id)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    });
}

const sendMessage = (keywords) => {
    return fetch.post('second/credit/collect2/sendMessage', keywords)
    .then(response => {
        return response;
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    columns,
    querySearch,
    getDetailById,
    sendMessage
}